import React from 'react'
import { Text } from '../../vanilla'

interface RapidDeliveryETAProps {
  isBasket?: boolean
  popover?: boolean
}

export const RapidDeliveryETA = ({isBasket, popover}: RapidDeliveryETAProps) => {
return (
  <Text variant={isBasket || popover ? "text4" : "text3"} data-test-selector="rapid-delivery-eta" lineHeight="none">
    Today, {!isBasket || !popover && <br/>}within 40 to 50 mins
  </Text>
)
}